import { useState, useEffect } from 'react'

type SupportsFullScreen = {
  fullscreenElement?: Element
  webkitFullscreenElement?: Element
  mozFullScreenElement?: Element
  msFullscreenElement?: Element
}
// Helper function to get the fullscreen element
const getFullscreenElement = (): Element | null =>
  (document as SupportsFullScreen).fullscreenElement ||
  (document as SupportsFullScreen).webkitFullscreenElement ||
  (document as SupportsFullScreen).mozFullScreenElement ||
  (document as SupportsFullScreen).msFullscreenElement ||
  null

// Hook to get the current fullscreen state
export const useFullscreenStatus = (): boolean => {
  const [isFullscreen, setIsFullscreen] = useState<boolean>(getFullscreenElement() != null)
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(getFullscreenElement() != null)
    }

    // Add event listeners for fullscreen changes
    document.addEventListener('fullscreenchange', handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange) // Safari/older Chrome
    document.addEventListener('mozfullscreenchange', handleFullscreenChange) // Older Firefox
    document.addEventListener('MSFullscreenChange', handleFullscreenChange) // IE/Edge

    // Cleanup listeners on component unmount
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange)
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange)
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange)
    }
  }, [])

  return isFullscreen
}
